import { render, staticRenderFns } from "./Event.vue?vue&type=template&id=dcd48908&scoped=true&"
import script from "./Event.vue?vue&type=script&lang=js&"
export * from "./Event.vue?vue&type=script&lang=js&"
import style0 from "./Event.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Event.vue?vue&type=style&index=1&id=dcd48908&scoped=true&lang=css&"
import style2 from "./Event.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd48908",
  null
  
)

export default component.exports